// extracted by mini-css-extract-plugin
export default {"sidInput":"OffersPage_sidInput__qIgXN","sidTitle":"OffersPage_sidTitle__1pTX+","sidGrid":"OffersPage_sidGrid__Rk7cJ","sidGrid_Container":"OffersPage_sidGrid_Container__Ti8ra"};